import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Building2, Instagram, Facebook, Mail, Phone, ExternalLink, Compass, Globe, Home as HomeIcon, Share2, Bell, ShieldCheck, Award } from 'lucide-react';
const profiles = [{
  title: 'Keller Williams',
  icon: Compass,
  url: 'https://rothgetsresults.kw.com/'
}, {
  title: 'Website',
  icon: Globe,
  url: 'https://rothgetsresults.kw.com/'
}, {
  title: 'Zillow',
  icon: HomeIcon,
  url: 'https://www.zillow.com/profile/RothGetsResults'
}];
export function ProfileHeroLinkedIn() {
  const handleShare = async () => {
    if (navigator.share) {
      await navigator.share({
        title: 'Krystle Roth — Eaves Pro Profile',
        text: "See Krystle Roth's verified performance data on Eaves",
        url: window.location.href
      });
    } else {
      await navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    }
  };
  return <section className="bg-brand-offwhite pb-12" data-id="element-197">
      {/* Banner */}
      <div className="h-48 md:h-64 bg-gradient-to-r from-brand-sage via-brand-sandstoneBg to-brand-light relative" data-id="element-198">
        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-forest to-transparent" data-id="element-199"></div>

        {/* Top bar */}
        <div className="max-w-6xl mx-auto px-6 md:px-12 pt-6 flex items-center justify-between relative z-10" data-id="element-200">
          <a href="/" className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/60 backdrop-blur-md border border-white/40 hover:bg-white/80 rounded-full transition-colors shadow-sm" data-id="element-201">

            <img src="/eaves_favicon_transparent.png" alt="Eaves" className="h-5 w-5 brightness-0 opacity-80" data-id="element-202" />

            <span className="hidden sm:inline text-sm text-brand-dark font-serif font-medium tracking-wide" data-id="element-203">
              Eaves
            </span>
          </a>
          <div className="flex items-center gap-2" data-id="element-204">
            <button onClick={handleShare} className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-brand-dark bg-white/60 backdrop-blur-md border border-white/40 hover:bg-white/80 rounded-full transition-colors shadow-sm" data-id="element-205">

              <Share2 size={15} data-id="element-206" />
              <span className="hidden sm:inline" data-id="element-207">Share</span>
            </button>
            <button className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-white bg-brand-forest hover:bg-brand-forestHover rounded-full transition-colors shadow-sm" data-id="element-208">
              <Bell size={15} data-id="element-209" />
              <span className="hidden sm:inline" data-id="element-210">Subscribe</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Card */}
      <div className="max-w-5xl mx-auto px-4 md:px-8 -mt-16 md:-mt-24 relative z-20" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl shadow-premium border border-brand-light p-6 md:p-8" data-id="element-212">

          <div className="flex flex-col md:flex-row gap-6 md:gap-8" data-id="element-213">
            {/* Left Column: Photo & Badge */}
            <div className="flex flex-col items-center md:items-start shrink-0" data-id="element-214">
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border-4 border-white shadow-md bg-white -mt-16 md:-mt-20 relative z-10" data-id="element-215">
                <img src="https://photos.zillowstatic.com/fp/61cb597d9d66b64e3d6a3ed851754390-h_l.jpg" alt="Krystle Roth" className="w-full h-full object-cover" data-id="element-216" />

              </div>
            </div>

            {/* Right Column: Info */}
            <div className="flex-1 text-center md:text-left pt-2 md:pt-0" data-id="element-217">
              <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-4" data-id="element-218">
                <div data-id="element-219">
                  <h1 className="text-3xl md:text-4xl font-serif font-semibold mb-1 text-brand-dark" data-id="element-220">
                    Krystle Roth
                  </h1>
                  <h2 className="text-lg text-brand-muted font-serif italic mb-3" data-id="element-221">
                    Broker · Luxury Certified
                  </h2>
                  <div className="inline-flex items-center gap-1.5 bg-brand-sage/50 border border-brand-sage text-brand-forest px-3 py-1 rounded-full text-xs font-medium tracking-wide mb-4" data-id="element-222">
                    <Building2 size={14} data-id="element-223" />
                    <span data-id="element-224">Keller Williams · Roth Real Estate Group</span>
                  </div>
                  <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 text-sm text-brand-muted" data-id="element-225">
                    <span className="flex items-center gap-1.5" data-id="element-226">
                      <MapPin size={14} className="text-brand-forest" data-id="element-227" />
                      Redlands · Inland Empire, CA
                    </span>
                    <span className="hidden sm:inline text-brand-light" data-id="element-228">|</span>
                    <span className="flex items-center gap-1.5" data-id="element-229">
                      <ShieldCheck size={14} className="text-brand-forest" data-id="element-230" />
                      DRE #01492471 · Verified
                    </span>
                  </div>
                </div>

                {/* Social Actions */}
                <div className="flex flex-wrap items-center justify-center md:justify-end gap-2" data-id="element-231">
                  <a href="https://www.instagram.com/roth_real_estate_group/" className="w-9 h-9 rounded-full bg-brand-offwhite hover:bg-brand-sage text-brand-muted hover:text-brand-forest flex items-center justify-center transition-colors" data-id="element-232">
                    <Instagram size={16} data-id="element-233" />
                  </a>
                  <a href="https://www.facebook.com/p/Krystle-Roth-Realtor-100063780903470/" className="w-9 h-9 rounded-full bg-brand-offwhite hover:bg-brand-sage text-brand-muted hover:text-brand-forest flex items-center justify-center transition-colors" data-id="element-234">
                    <Facebook size={16} data-id="element-235" />
                  </a>
                  <span className="w-px h-5 bg-brand-light mx-1" data-id="element-236"></span>
                  <a href="mailto:Krystle@rothgetsresults.com" className="w-9 h-9 rounded-full bg-brand-offwhite hover:bg-brand-sage text-brand-muted hover:text-brand-forest flex items-center justify-center transition-colors" data-id="element-237">

                    <Mail size={16} data-id="element-238" />
                  </a>
                  <a href="tel:+19096547684" className="w-9 h-9 rounded-full bg-brand-offwhite hover:bg-brand-sage text-brand-muted hover:text-brand-forest flex items-center justify-center transition-colors" data-id="element-239">

                    <Phone size={16} data-id="element-240" />
                  </a>
                </div>
              </div>

              {/* Profiles Row */}
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-2 mb-8" data-id="element-241">
                {profiles.map(p => {
                const Icon = p.icon;
                return <a key={p.title} href={p.url} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-brand-offwhite hover:bg-brand-sage text-sm text-brand-dark transition-colors border border-brand-light" data-id="element-242">

                      <Icon size={14} className="text-brand-muted" data-id="element-243" />
                      <span className="font-medium" data-id="element-244">{p.title}</span>
                      <ExternalLink size={12} className="text-brand-muted opacity-50" data-id="element-245" />

                    </a>;
              })}
              </div>

              {/* Credentials Row — verified sources only */}
              <div className="grid grid-cols-2 gap-4 pt-6 border-t border-brand-light" data-id="element-246">
                <div className="text-center md:text-left" data-id="element-247">
                  <p className="text-xl font-mono text-brand-dark font-semibold mb-1" data-id="element-248">
                    21 years
                  </p>
                  <p className="text-xs text-brand-muted" data-id="element-249">
                    Experience ·{' '}
                    <a href="https://www.fastexpert.com/agents/krystle-roth-2375/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-0.5 hover:text-brand-forest hover:underline" data-id="element-250">
                      FastExpert <ExternalLink size={10} data-id="element-251" />
                    </a>
                  </p>
                </div>
                <div className="text-center md:text-left" data-id="element-252">
                  <div className="flex items-center justify-center md:justify-start gap-1.5 mb-1" data-id="element-253">
                    <Award size={16} className="text-brand-forest" data-id="element-254" />
                    <p className="text-xl font-mono text-brand-dark font-semibold" data-id="element-255">
                      Top 20%
                    </p>
                  </div>
                  <p className="text-xs text-brand-muted" data-id="element-256">
                    Nationwide · Luxury Certified ·{' '}
                    <a href="https://www.fastexpert.com/agents/krystle-roth-2375/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-0.5 hover:text-brand-forest hover:underline" data-id="element-257">
                      FastExpert <ExternalLink size={10} data-id="element-258" />
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}